import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-wrap items-center gap-3 rounded-lg border border-warning-300 bg-warning-50 px-4 py-3",
  role: "alert"
}
const _hoisted_2 = { class: "flex-1 text-normal text-gray-900" }
const _hoisted_3 = { class: "flex gap-2" }

import { AlertTriangle } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import type { UnsavedInputAction } from '@/composables/inventory/useUnsavedInputGuard';

/* Shown in a bulk count or purchase when another farm is picked or the dialog is closed while something is typed. */

export default /*@__PURE__*/_defineComponent({
  __name: 'UnsavedInputWarning',
  props: {
    action: {},
    farmName: {}
  },
  emits: ["confirm", "keep"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AlertTriangle), {
      class: "size-5 shrink-0 text-warning-700",
      "aria-hidden": "true"
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(`views.health.inventory.unsavedInput.${props.action}.warning`, { farm: _ctx.farmName })), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Button), {
        variant: "outline",
        size: "sm",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('keep')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('views.health.inventory.unsavedInput.keep')), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        size: "sm",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`views.health.inventory.unsavedInput.${props.action}.confirm`)), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})